import { render, staticRenderFns } from "./read_more.vue?vue&type=template&id=589bb914&scoped=true&"
import script from "./read_more.vue?vue&type=script&lang=js&"
export * from "./read_more.vue?vue&type=script&lang=js&"
import style0 from "./read_more.vue?vue&type=style&index=0&id=589bb914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589bb914",
  null
  
)

export default component.exports